// src/constants/dilSwipeModes.js
export const DIL_SWIPE_MODES = {
  DATING: 'dating',
  NETWORKING: 'networking',
  FRIENDS: 'friends',
  ACTIVITIES: 'activities',
  HOBBIES: 'hobbies',
  EVENTS: 'events',
  FREELANCE: 'freelance',
};

export const MODE_LABELS = {
  dating: '💖 Dating',
  networking: '💼 Networking',
  friends: '🤝 Friends',
  activities: '🍽️ Decide Places',
  hobbies: '🎨 Hobbies',
  events: '🎟️ Events',
  freelance: '🛠️ Freelance / Gigs',
};
